import React from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider, SensorSelectionProvider } from 'context';
import { initializeSentry } from 'sentry';
import { AppPostHogProvider } from 'posthog';
import { App } from 'app';

import './tailwind.css';
import 'index.scss';
import { SelfRecordingProvider } from 'context/self-recording-context/context';
import { StoreProvider } from 'context/store-context/context';
import { CollaboratorsProvider } from 'context/collaborators-context/context';

initializeSentry();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <AppPostHogProvider>
        <AppProvider>
          <SensorSelectionProvider>
            <SelfRecordingProvider>
              <StoreProvider>
                <CollaboratorsProvider>
                  <App />
                </CollaboratorsProvider>
              </StoreProvider>
            </SelfRecordingProvider>
          </SensorSelectionProvider>
        </AppProvider>
      </AppPostHogProvider>
    </React.StrictMode>,
  );
}
